export default {
	pl: {
		titles: {
			login: 'Logowanie',
			activate: 'Logowanie - aktywacja konta',
			register: 'Rejestracja',
			passwordResetStepOne: 'Zmiana hasła - krok pierwszy',
			passwordResetStepTwo: 'Zmiana hasła - krok drugi',
		},
		auth: {
			loginFailed: 'Podany e-mail lub hasło nie jest prawidłowe',
			exists: 'Użytkownik o tym adresie e-mail jest już zarejestrowany',
			activateAccountFailed: 'To konto zostało już aktywowane lub link aktywacyjny jest niepoprawny',
			activateAccountPassed: 'Konto zostało aktywowane, możesz się teraz zalogować',
			passwordReset: {
				failed: 'Wystąpił błąd, prosimy spróbować ponownie później',
				email: {
					passed: 'Na podany adres e-mail został wysłany link służący do odzyskania hasła.'
				},
				password: {
					passed: 'Hasło zostało zmienione, możesz się teraz zalogować.',
					failed: 'Upewnij się, że dobrze otworzyłeś link przypominający hasło'
				},
			},
		},
		validator: {
			notEmpty: 'To pole nie może być puste',
			email: 'To pole powinno zawierać poprawny adres e-mail',
			min: 'To pole powinno zawierać minimum {count} znaków',
			max: 'To pole powinno zawierać maksimum {count} znaków',
			integer: 'To pole powinno zawierać wartość liczbową',
			trueInteger: 'To pole powinno zawierać wartość liczbową',
			singleString: 'To pole powinno zawierać jedno słowo',
			sameAs: 'To pole musi być identyczne jak pole {n}',
			isTrue: 'Pole wymagane',
			rootDomain: 'To pole powinno zawierać domenę lub subomenę z pominięciem www oraz http/https',
			url: 'To pole powinno zawierać poprawny adres url',
			float: 'To pole powinno zawierać poprawną kwotę',
			unsigned: 'To pole powinno zwierać liczbę większą niż 0',
			numberMin: 'To pole powinno zawierać wartośc większą niż {count}',
			numberMax: 'To pole powinno zawierać wartość mniejszą niż {count}',
			uppercase: 'To pole musi być złożone w całości z dużych znaków',
			verifyIban: 'Podany numer konta jest nieprawidłowy',

			notEmptyRadioGroup: 'Musisz wybrać jedno z pól',

			fields: {
				password: 'Hasło',
				new_password: 'Nowe hasło',
			},
		}
	}
}
